import { render, staticRenderFns } from "./CartDiamondCustom.vue?vue&type=template&id=bace3ece&scoped=true"
import script from "./CartDiamondCustom.vue?vue&type=script&lang=js"
export * from "./CartDiamondCustom.vue?vue&type=script&lang=js"
import style0 from "./CartDiamondCustom.vue?vue&type=style&index=0&id=bace3ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bace3ece",
  null
  
)

export default component.exports